// Match S3 virtual-hosted-style URLs:
//   https://<bucket>.s3.amazonaws.com/<key>
//   https://<bucket>.s3.<region>.amazonaws.com/<key>
const S3_URL_PATTERN = /^https:\/\/[^/]+\.s3(?:\.[^/]+)?\.amazonaws\.com\/(.+)$/;

export function rewriteAudioUrl(url: string): string {
  if (!url) return url;
  const match = url.match(S3_URL_PATTERN);
  if (!match) return url;
  const domain = process.env.REACT_APP_AUDIO_CLOUDFRONT_DOMAIN || 'd2m3bicf9rd0ra.cloudfront.net';
  return `https://${domain}/${match[1]}`;
}
